module.exports = __webpack_public_path__ + "static/media/france-flag.b313ca72.png";